module.exports = __webpack_public_path__ + "assets/c711af55b867a9f09df027953af5084b.png";